import Drawer from "@material-ui/core/Drawer";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import { useTheme } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Business from "@material-ui/icons/Business";
import Home from "@material-ui/icons/Home";
import MailIcon from "@material-ui/icons/Mail";
import InboxIcon from "@material-ui/icons/MoveToInbox";
import People from "@material-ui/icons/People";
import Person from "@material-ui/icons/Person";
import pathOr from "ramda/src/pathOr";
import React from "react";
import { useQuery } from "react-query";
import { NavLink } from "react-router-dom";

import { SIDEBAR_WIDTH } from "../../app/theme";
import logo from "../../assets/img/logo.svg";
import { QUERY_AUTH } from "../../services/auth/queries";

const DefaultIcon = InboxIcon;

const links = {
  commonTop: [
    { path: "/tickets", name: "Заявки", icon: () => <InboxIcon /> },
    { path: "/stocks", name: "Остатки", icon: () => <MailIcon /> },
    { path: "/storehouses", name: " Склады", icon: () => <Home /> },
  ],
  Admin: [],
  Employees: [
    { path: "/companies", name: " Организации", icon: () => <Business /> },
    { path: "/users", name: " Пользователи", icon: () => <People /> },
    {
      path: "/product-types",
      name: " Типы аппаратов",
      icon: () => <DefaultIcon />,
    },
  ],
  NotEmployees: [
    { path: "/users/me", name: "Профиль", icon: () => <Person /> },
    {
      path: "/companies/me",
      name: " Организация",
      icon: () => <Business />,
    },
  ],
};

const MenuLink = ({ link }) => (
  <ListItem
    button
    exact
    component={NavLink}
    to={link.path}
    activeClassName="Mui-selected"
    onClick={link.onClick}
  >
    {link.icon && <ListItemIcon style={{ minWidth: 35 }}>{link.icon()}</ListItemIcon>}
    {link.name}
  </ListItem>
);

export const Logo = ({ theme }) => (
  <Typography
    variant="h4"
    align="center"
    style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexShrink: 0,
      height: 64,
      cursor: "default",
      background: theme.palette.primary.main,
      boxShadow:
        "0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)",
    }}
  >
    <img src={logo} alt="ACCO Logo" style={{ maxWidth: 120 }} />
  </Typography>
);

const Sidebar = () => {
  const { data: user } = useQuery(QUERY_AUTH);
  const role = pathOr("", ["role", "name"], user);

  const theme = useTheme();

  return (
    <div style={{ width: SIDEBAR_WIDTH }}>
      <Drawer
        variant="permanent"
        anchor={theme.direction === "rtl" ? "right" : "left"}
        PaperProps={{
          style: { width: SIDEBAR_WIDTH },
        }}
      >
        <Logo theme={theme} />
        <List
          component="nav"
          aria-labelledby="nested-list-subheader"
          style={{ paddingTop: 35 }}
        >
          {links.commonTop.map((link) => (
            <MenuLink key={link.name} link={link} />
          ))}

          {(links[role] || []).map((link) => (
            <MenuLink key={link.name} link={link} />
          ))}

          {role !== "Employees" &&
            links.NotEmployees.map((link) => <MenuLink key={link.name} link={link} />)}
        </List>
      </Drawer>
    </div>
  );
};

export default Sidebar;
